export function getSeleccionado(state) {
    return state.seleccionado
}
